import { useQuery, QueryFunction } from 'react-query';
import { getAllCompanies, Company, GetCompaniesQueries } from '../../services/apiSLTP/materials/companies';

type UseCompaniesQueryOptions = {
    queries?: GetCompaniesQueries;
};

const getCompaniesQuery: QueryFunction<Company[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseCompaniesQueryOptions];
    const { queries } = options;

    const response = await getAllCompanies(queries);
    return response.data;
};

export const useCompaniesQuery = (options: UseCompaniesQueryOptions) => {
    return useQuery(['companies', options], getCompaniesQuery);
};
